module.exports = __webpack_public_path__ + "images/branding/manpower/marketing_site_logo.gif";